import { useMutation } from "@tanstack/react-query";
import { runMatrix, type RunMatrixInput } from "@/domains/matrix";
import { useMatrixInvalidation } from "./use-matrix-invalidation";

// A run queues analyses; the rail shows no status, so only the detail refreshes.
export function useRunMatrix(collectionId: string) {
  const { invalidateDetail } = useMatrixInvalidation(collectionId);

  return useMutation({
    mutationFn: (input: RunMatrixInput = {}) => runMatrix(collectionId, input),
    onSettled: invalidateDetail,
  });
}
